import type { PortalModule } from '@ciimar/shared';
import { MODULE_KEY } from '../portal/modules';
import { useT } from '../lib/i18n';

/**
 * A granted module whose screens are not built yet (RH, SafeLab). Shows the
 * module name and intent so access can be assigned and tested ahead of the
 * feature work.
 */
export function ModulePlaceholder({ module }: { module: PortalModule }) {
  const t = useT();
  return (
    <section>
      <div className="page-head">
        <h2>{t(`modules.${MODULE_KEY[module]}`)}</h2>
      </div>
      <p className="muted">{t(`moduleHints.${MODULE_KEY[module]}`)}</p>
      <div className="alert">{t('admin.placeholder.inPreparation')}</div>
    </section>
  );
}
